import React from 'react';

const licenses = [
    {
        name: 'Akta Pendirian',
        description: 'No. 02 / Tanggal 14 April 2020'
    },
    {
        name: 'Akta Perubahan',
        description: 'No. 02 / Tanggal 31 Juli 2024'
    },
    {
        name: 'SK Kemenkumham',
        description: 'Nomor AHU-0020321.AH.01.01.TAHUN 2020'
    },
    {
        name: 'SP Kemenkumham',
        description: 'Nomor AHU-AH.01.09-0233881 TAHUN 2024'
    },
    {
        name: 'NIB',
        description: '0220102451756'
    },
    {
        name: 'KBLI',
        description: '71023 - Jasa Inspeksi Periodik'
    },
    {
        name: 'NPWP',
        description: '94.773.475.2-403.000'
    },
    {
        name: 'SKP Perusahaan',
        description: [
            'Nomor 5/20/AS.01.02/1/2023 - ELES',
            'Nomor 5/24/AS.01.02/1/2023 - PAA',
            'Nomor 5/25/AS.01.02/1/2023 - PTP',
            'Nomor 5/1151/AS.01.02/XII/2022 - IL/IPP',
            'Nomor 5/6778/AS.01.04/V/2023 - IPK'
        ]
    },
    {
        name: 'SKP Ahli K3',
        description: [
            'Nomor 5/16017/AS.02.01/XI/2021 - ELES',
            'Nomor 5/7325/AS.01.04/V/2024 - PAA',
            'Nomor 5/12599/AS.01.04/VII/2024 - PTP',
            'Nomor 5/17821/AS.01.04/IX/2024 - IL/IPP',
            'Nomor 5/20691/AS.01.04/X/2024 - IPK'
        ]
    }
]

class Document extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white inner-page-padding">
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-left">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> License</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* IMAGE Team START */}
                        <div className="section-content">
                            <div id="">
                                <table className="table-striped">
                                    <tbody>
                                        {licenses.map((license, index) => (
                                            <tr style={{paddingTop: '100px'}} key={index}>
                                                <td className="">{license.name}</td>
                                                <td className="font-weight-600">
                                                    {Array.isArray(license.description) ? (
                                                        <ul>
                                                            {license.description.map((desc, idx) => (
                                                                <li key={idx}>{desc}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        license.description
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Document;